<template>
  <div class="container">
    <div class="top-box">
      <div class="flexrbc">
        <div class="flexr0c">
          <div class="title-label"></div>
          <div class="title">矿云通资金明细</div>
        </div>
      </div>
    </div>
    <div class="search-box">
      <div class="flexr0c filter">
        <div class="label">时间范围</div>
        <Row>
          <Col span="12">
            <DatePicker :value="dateValue" format="yyyy/MM/dd" type="daterange" placement="bottom-end"
                        placeholder="选择日期" style="width: 240px" @on-change="handleChange"></DatePicker>
          </Col>
        </Row>
        <RadioGroup v-model="checkBox1">
          <Radio label="充值收入"></Radio>
          <Radio label="过站退税"></Radio>
          <Radio label="转账支出"></Radio>
          <Radio label="过站扣税"></Radio>
          <Radio label="补扣税"></Radio>
        </RadioGroup>
        <div class="search-btn" @click="getPage(1)">查询</div>
      </div>
    </div>
    <div class="content-box">
      <div class="content">
        <div class="title-box flexr0c">
          <div class="title">充值收入(元)</div>
          <div class="title">过站退税(元)</div>
          <div class="title">转账支出(元)</div>
          <div class="title">过站扣税(元)</div>
          <div class="title">补扣税(元)</div>
        </div>
        <div class="item-box flexr0c">
          <div class="num ">{{ moneyInfo.income }}</div>
          <div class="num ">{{ moneyInfo.otherincome }}</div>
          <div class="num ">{{ moneyInfo.transfer }}</div>
          <div class="num ">{{ moneyInfo.taxstation }}</div>
          <div class="num ">{{ moneyInfo.tax }}</div>
        </div>
        <Table max-height="" :loading="loading" border stripe :columns="tableHead" :data="tableData">
          <template class="flexr0c" slot-scope="{ row, index }" slot="authority">
            <div class="flexr0c">
              <div class="look flexr0c" @click="look(index)" style="cursor: pointer;">
                <img src="../../assets/imgs/home/certificate.png" alt="" style="margin-right:5px"
                     v-if="tableData[index].authority!=''">
                <div class="item">{{ tableData[index].authority }}</div>
              </div>
            </div>
          </template>
        </Table>
        <div style="margin: 10px;overflow: hidden">
          <div style="float: right;">
            <Page :total="total" :pageSize="pageSize" :current="1" @on-change="changePage" show-elevator
                  show-total></Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "specialMoney",
  data() {
    return {
      msg: "",
      dateValue: [],
      checkBox1: '',
      kind: '',
      total: 0,
      pageSize: 8,
      index: -1,
      moneyInfo: {},
      print: false,
      loading: false,
      proof: {
        changeDate: {},
        infundBean: {},
        tradeRecordBean: {},
      },
      tableHead: [
        {
          title: "时间",
          key: "time",
          width: 180,
          resizable: true,
        },
        {
          title: "操作类型",
          key: "actionType",
          width: 110,
          resizable: true,
        },
        {
          title: "资金变动",
          key: "moneychange",
          width: 145,
          resizable: true,
        },
        {
          title: "权限",
          slot: "authority",
          width: 180,
          resizable: true,
        },
        {
          title: "账户余额",
          key: "balance",
          width: 140,
          resizable: true,
        },
        {
          title: "备注",
          key: "remark",
          resizable: true,
        }
      ],
      tableData: [],
      otherInCome: '',
    };
  },
  methods: {
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
        ;
      }
      ;
      return fmt;
    },
    changePage(page) {
      this.getPage(page)
    },
    handleChange(daterange) {
      this.dateValue = daterange
    },
    printPage() {
      window.print()
      this.print = false
    },
    look(index) {
      // this.print = true
      // this.getCertificate(index)
      let id = this.tableData[index].id
      this.$router.push({
        name: 'print',
        params: {
          index: id
        }
      })
    },
    getKind() {
      this.kind = ''
      this.checkBox1.indexOf('充值收入') == -1 ? this.kind : this.kind = '1'
      this.checkBox1.indexOf('过站退税') == -1 ? this.kind : this.kind = '2'
      this.checkBox1.indexOf('转账支出') == -1 ? this.kind : this.kind = '5'
      this.checkBox1.indexOf('过站扣税') == -1 ? this.kind : this.kind = '6'
      this.checkBox1.indexOf('补扣税') == -1 ? this.kind : this.kind = '4'
      // this.kind = this.kind.substr(0, this.kind.length - 1)
    },
    getCertificate(index) {
      var session = JSON.parse(localStorage["session"]);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "AcxniMm970m5sH9WeCQjpAj6Oi8uznJu",
        id: this.tableData[index].id
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.proof = res.data
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getPage(index) {
      this.loading = true
      this.getKind()
      var session = JSON.parse(localStorage["session"]);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: "rsDAURNOFqd9ynnjz1oJMnGxpU5tC3B6",
        // startTime: this.dateValue[0],
        // endTime: this.dateValue[1],
        changeKind: this.kind,
        pageIndex: index,
        pageSize: this.pageSize,
      };
      console.log(data, 'data')
      this.checkBox1.indexOf('过站退税') != -1 ? data.otherInCome = 1 : data.otherInCome = ''

      if (this.dateValue.length != 0) {
        data.startTime = this.dateValue[0].replace(/\//g, '-')
        data.endTime = this.dateValue[1].replace(/\//g, '-')
      }
      if (data.changeKind == '') {
        delete data.changeKind
      }
      if (data.otherInCome == '') {
        delete data.otherInCome
      }
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.total = res.data.count
          this.moneyInfo.income = res.data.INCOME
          this.moneyInfo.otherincome = res.data.OTHERINCOME
          this.moneyInfo.tax = res.data.TAX
          this.moneyInfo.taxstation = res.data.TAXSTATION
          this.moneyInfo.transfer = res.data.TRANSFER
          res.data.list.forEach((item) => {
            item.time = item.changeDateStr
            switch (item.changeKind) {
              case 1:
                item.actionType = '充值收入'
                break
              case 5:
                item.actionType = '转账支出'
                break
              case 6:
                item.actionType = '过站扣税'
                break
              case 4:
                item.actionType = '补扣税'
                break
              case 8:
                item.actionType = '抵扣'
              default:
                break
            }
            (item.changeType == 1 && item.changeKind != 1) ? item.actionType = '过站退税' : item.actionType
            item.balance = item.newMoney
            item.remark = item.changeReason
            item.changeType == 1 ? item.moneychange = item.changeMoney : item.moneychange = '-' + item.changeMoney;
            (item.changeKind == 1 && item.infundType != 6) ? item.authority = '查看存款凭证' : item.authority = ''
          })
          this.tableData = res.data.list
          this.loading = false
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
          this.loading = false;
        }
      });
    },
  },
  created() {
    let date2 = this.dateFormat("YYYY-mm-dd", new Date())
    let date1 = this.dateFormat("YYYY-mm-", new Date()) + '01'
    this.dateValue.push(date2)
    this.dateValue.push(date2)
    this.getPage(1);
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  // height: 775px;
  background: #f2f3f5;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #f2f3f5;
  // position: relative;

  .top-box {
    background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 40px;

    & > div {
      height: 100%;
      width: 928px;
      margin: 0 auto;
    }

    .title-label {
      width: 4px;
      height: 14px;
      background: #2c59c3;
    }

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #2c59c3;
      letter-spacing: 0.4px;
      margin-left: 6px;
    }

    .addOrg {
      background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
      border: 1px solid #4c9b25;
      border-radius: 6px;
      width: 110px;
      height: 30px;
      cursor: pointer;

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      .btn {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
      }
    }
  }

  .search-box {
    // overflow: hidden;

    .filter {
      margin: 20px 0;

      .label {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #616c84;
        margin: 0 10px 0 26px;
      }

      /deep/ .ivu-date-picker-focused input,
      /deep/ .ivu-date-picker-focused input {
        font-size: 14px;
      }

      /deep/ .ivu-select-selected-value,
      /deep/ .ivu-select-item {
        text-align: start;
      }

      /deep/ .ivu-checkbox-group {
        margin: 0 40px;
      }

      /deep/ .ivu-input-with-suffix {
        cursor: pointer;
      }

      /deep/ .ivu-select-selection {
        height: 38px;
        background: #ffffff;
        // border: 1px solid #DFDFDF;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
      }

      /deep/ .ivu-select-placeholder,
      /deep/ .ivu-select-selected-value {
        height: 38px;
        line-height: 38px;
        padding-left: 24px;
        text-align: start;
      }

      /deep/ .ivu-input-suffix {
        line-height: 38px;
      }

      /deep/ .ivu-input-with-suffix {
        height: 38px;
        line-height: 38px;
        padding-left: 24px;
        background: #ffffff;
        // border: 1px solid #DFDFDF;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
      }

      .search-btn {
        background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
        border: 1px solid #006bc4;
        border-radius: 6px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
        }
      }
    }
  }

  .content-box {
    width: 980px;
    min-height: 530px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;

    .content {
      width: 928px;
      margin-top: 30px;

      .title-box {
        width: 928px;
        height: 40px;
        background-color: rgba(224, 229, 240, 0.3);

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #8b93a7;
          flex: 1;
          text-align: center;
        }
      }

      .item-box {
        width: 928px;
        height: 80px;

        .num {
          font-family: Impact;
          font-size: 24px;
          flex: 1;
          margin: 25px 0;
          color: #2c59c3;
          text-align: center;
        }
      }

      /deep/ .ivu-table th {
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }

      /deep/ .ivu-table th:last-child {
        border-top-right-radius: 10px;
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }

      /deep/ .ivu-table th:first-child {
        // border-top-left-radius: 10px;
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }
    }
  }

  /deep/ .ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/ .ivu-select-selected-value,
  /deep/ .ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #fafafa;
  }

  /deep/ span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/ .ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/ .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #2d8cf0;
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
  }

  /deep/ .ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/ .ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/ .ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/ .ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/ .ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/ .ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/ .ivu-table:before {
    display: none;
  }
}
</style>
